// src/lib/secureApi.ts

import CryptoJS from 'crypto-js';

// Make sure to set NEXT_PUBLIC_ENCRYPTION_KEY in your .env.local to a 32-character secret
const SECRET_KEY = process.env.NEXT_PUBLIC_ENCRYPTION_KEY;
if (!SECRET_KEY) {
  throw new Error('Missing NEXT_PUBLIC_ENCRYPTION_KEY in environment variables');
}
// Parse the secret key to a WordArray
const KEY = CryptoJS.enc.Utf8.parse(SECRET_KEY);

// Helper to generate a random IV (16 bytes)
function generateIV(): CryptoJS.lib.WordArray {
  return CryptoJS.lib.WordArray.random(16);
}

// Encrypts a string or object and returns a string in the format ivHex:ciphertext
export function encryptData(data: object | string): string {
  const plaintext = typeof data === 'string' ? data : JSON.stringify(data);
  const iv = generateIV();
  const encrypted = CryptoJS.AES.encrypt(plaintext, KEY, { iv });
  const ivHex = iv.toString(CryptoJS.enc.Hex);
  return `${ivHex}:${encrypted.toString()}`;
}

// Decrypts a string in the format ivHex:ciphertext and returns the original object or string
export function decryptData<T = any>(payload: string): T {
  const [ivHex, ciphertext] = payload.split(':');
  const iv = CryptoJS.enc.Hex.parse(ivHex);
  const bytes = CryptoJS.AES.decrypt(ciphertext, KEY, { iv });
  const decrypted = bytes.toString(CryptoJS.enc.Utf8);
  try {
    return JSON.parse(decrypted) as T;
  } catch {
    return decrypted as any;
  }
}